var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-review-recommended-icon.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\"\n\t viewBox=\"0 0 28.2 28.5\" style=\"enable-background:new 0 0 28.2 28.5;\" xml:space=\"preserve\" role=\"img\" aria-hidden=\"true\">\n<g id=\"Phase-1-_x28_part-2_x29_-_x28_MR_x29_\">\n\t<g id=\"XS_Reviews_Phase1_D1_1\" transform=\"translate(-174.000000, -2713.000000)\">\n\t\t<g id=\"Group-9-Copy-2\" transform=\"translate(175.000000, 2714.000000)\">\n\t\t\t<circle id=\"Oval-4\" class=\"c-product-reviews-summary__recommended-icon\" cx=\"13.1\" cy=\"13.2\" r=\"12.5\"/>\n\t\t\t<polyline id=\"Path-2\" class=\"c-product-reviews-summary__recommended-icon\" points=\"5.9,14.6 9.6,18.3 19.6,8.3 \t\t\t\"/>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-review-recommended-icon.j2"] , dependencies)